export default "__VITE_ASSET__BqC7mBMH__"